
//城市排名总页面
import React, { Component } from "react";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { cityRank } from "@/fetch/fetchApi";
import {
  UpOutlined,
  MinusOutlined,
  DownOutlined
} from "@ant-design/icons";
const defaultDate = moment();

@monthPickerHoc
class CityRankTotal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [],
      startTime:moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
      cityIds:"",
      provinceIds:"",
    };

    
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubId,
      page: 1,
    };
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    componentWillMount() {
      this.init();
    }

    init() {
      this.setState({
        tableConfig: {
          tableColumns: [
            
         {
            name: "排名",
            key: "rankNum",
            colType: "textCol",
            align: "center",
            
          },
          {
            name: "城市",
            key: "cityName",
            colType: "textCol",
            align: "center",
            render: (value, row) => {
              if (row.lastDown == 1) {
                return (
                  <div style={{ display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                    <span style={{marginRight: '10px',minWidth:'200px',  maxWidth:'200px',overflow:"hidden"}}  title={value}>{value}</span>
                    <UpOutlined style={{ fontSize: '16px', color: '#53FF53' }}/>
                      
                    
                  </div>
                );
              } else if (row.lastDown == 2) {
                return (
                  <div style={{ display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                    <span style={{marginRight: '10px',minWidth:'200px',  maxWidth:'200px',overflow:"hidden"}} title={value}>{value}</span>
                    <DownOutlined style={{ fontSize: '16px', color: '#930000' }}/>
                    
                    
                  </div>
                );
              } else {
                return (
                  <div style={{ display: 'flex',justifyContent: 'center',alignItems: 'center'}}>
                    <span style={{marginRight: '10px',minWidth:'200px',   maxWidth:'200px',overflow:"hidden"}}  title={value}>{value}</span>
                    <MinusOutlined style={{ fontSize: '16px' }}/>
                    
                    
                  </div>
                );
              }
            },
          }, {
            name: "城市评分",
            key: "totalScore",
            colType: "textCol",
            align: "center",
          }, {
            name: "设备完好率",
            key: "deviceGoodRate",
            colType: "textCol",
            align: "center",
            render: (value) => {
              if (value) {
                return (value * 100).toFixed(2) + '%';
              } else {
                return "--";
              }
            },
          }, {
            name: "充电成功率",
            key: "successOrderRate",
            colType: "textCol",
            align: "center",
            render: (value) => {
              if (value) {
                return (value * 100).toFixed(2) + '%';
              } else {
                return "--";
              }
            },
          }, {
            name: "设备日均告警量",
            key: "unitStuWarnNum",
            colType: "textCol",
            align: "center",
            render: (value) => {
              if (value) {
                return value;
              } else {
                return "--";
              }
            },
          }],
          noPagination:{ position: ['top', 'None'] },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          tableChange: () => {
            // grid翻页页，排序， 筛选过滤时触发
            console.debug("change");
          },
          autoRefresh: 1, // 设置为true 直接加载grid数据
          dataApi: cityRank,
          tableKey: "statusLog",
          tableParam: {
            isKanBan: "2",
            pageCount: 1000,
            startTime:this.state.startTime,
            cityIds:this.state.cityIds,
            provinceIds:this.state.provinceIds,

          },
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    render() {
      return (
        <div className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "25px" }}>
          <div className="page-panel">
            <ScGridTable config={this.state.tableConfig} />
          </div>
          <div style={{ width:'50%', marginLeft: '60px',fontWeight: '400'}}>
          分值确定由以下几项组成 ：
设备完好率 40分

充电成功率 30分 （0订单算0分）

平均单桩告警量 30分（30天每天的均值算出来，5(暂定)以内是满分，5 /告警量 * 30）例如：设备完好率 100% 就是得到40分，80%就是得到32分。


          </div>
        </div>
      );
    }
}

export default CityRankTotal;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/cityRankTotal.js